export class Countries {
    public static readonly Usa = 'USA';
    public static readonly UnitedStates = 'United States';
    public static readonly UnitedStatesOfAmerica = 'United States of America';
    public static readonly Canada = 'Canada';
}

export class SelectableCountries {
    public static readonly 'United States' = 'United States';
    public static readonly 'Canada' = 'Canada';
}

export const CountriesOptions = Object.keys(SelectableCountries).map((country) => ({
    label: SelectableCountries[country],
    value: country
}));
